import { render, staticRenderFns } from "./PauseMenu.vue?vue&type=template&id=e48b6eb6&"
import script from "./PauseMenu.vue?vue&type=script&lang=ts&"
export * from "./PauseMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PauseMenu.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports